import { combineReducers } from 'redux';
import availableFacets, * as fromAvailable from './availableFacetsReducer';
import appliedFacets, * as fromApplied from './appliedFacetsReducer';

const filters = combineReducers({
  applied: appliedFacets,
  available: availableFacets,
});

export default filters;

export const getValidityOfAppliedFacets = state => {
  const availableById = fromAvailable.getItemIdsPerFacet(state.available);
  const appliedById = fromApplied.getItemIdsPerFacet(state.applied);

  const result = Object.entries(appliedById).reduce(
    (acc, [facet, items]) => {
      if (!availableById[facet]) {
        return {
          ...acc,
          isValid: false,
        };
      }
      const validItems = items.filter(item => availableById[facet].includes(item));
      if (validItems.length === items.length) {
        return { ...acc, [facet]: items };
      }
      const entry = validItems.length ? { [facet]: validItems } : {};
      return { ...acc, ...entry, isValid: false };
    },
    { isValid: true }
  );

  return result;
};

export const getAppliedFacetIds = state => fromApplied.getFacetIds(state.applied);
export const getAllAppliedFacetItemUids = state => fromApplied.getAllFacetItemUids(state.applied);
export const getAppliedFacetItemIds = (state, facetId) => fromApplied.getFacetItemIds(state.applied, facetId);

export const getFullFacetData = (state, facetId) => {
  const facet = fromAvailable.getFacet(state.available, facetId);
  const appliedItemIds = getAppliedFacetItemIds(state, facetId);
  return {
    ...facet,
    items: facet.items.map(item => ({
      ...item,
      selected: appliedItemIds.includes(item.id),
    })),
  };
};
export const getFullFacetItemData = (state, facetItemUid) =>
  fromAvailable.getFacetItemByUid(state.available, facetItemUid);
export const getAppliedFacetsForApiQuery = state => {
  return fromApplied.getForAPIQueryParam(state.applied);
};
export const getAppliedFacetsForURLHash = state => fromApplied.getForURLHash(state.applied);
